import { ACCOUNT, RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_ACCOUNT_DETAIL_FAILURE,
  FETCH_ACCOUNT_DETAIL_REQUEST,
  FETCH_ACCOUNT_DETAIL_SUCCESS,
  FETCH_LIMIT_REMAIN_FAILURE,
  FETCH_LIMIT_REMAIN_REQUEST,
  FETCH_LIMIT_REMAIN_SUCCESS,
  FETCH_LIST_ACCOUNT_FAILURE,
  FETCH_LIST_ACCOUNT_REQUEST,
  FETCH_LIST_ACCOUNT_SUCCESS,
  FETCH_LIST_ACCOUNT_LOGIN_FAILURE,
  FETCH_LIST_ACCOUNT_LOGIN_REQUEST,
  FETCH_LIST_ACCOUNT_LOGIN_SUCCESS,
  FETCH_CUSTOMER_POSITION_REQUEST,
  FETCH_CUSTOMER_POSITION_SUCCESS,
  FETCH_CUSTOMER_POSITION_FAILURE,
  SET_CONTACT_ID_STORE,
} from "./actions.type";
import {
  FetchAccountDetailFailure,
  FetchAccountDetailRequest,
  FetchAccountDetailSuccess,
  FetchLimitRemainFailure,
  FetchLimitRemainRequest,
  FetchLimitRemainSuccess,
  FetchListAccountFailure,
  FetchListAccountRequest,
  FetchListAccountSuccess,
  FetchListAccountLoginRequest,
  FetchListAccountLoginSuccess,
  FetchListAccountLoginFailure,
  FetchCustomerPositionRequest,
  FetchCustomerPositionSuccess,
  FetchCustomerPositionFailure,
  SetHasContactId,
} from "./types";

export const setHasContactId = (payload?: string): SetHasContactId => ({
  type: SET_CONTACT_ID_STORE,
  payload,
});

export const fetchListAccountRequest = (): FetchListAccountRequest => ({
  type: FETCH_LIST_ACCOUNT_REQUEST,
});

export const fetchListAccountSuccess = (payload?: RESPONSEDATA, hasKey?: string, signature?: string): FetchListAccountSuccess => ({
  type: FETCH_LIST_ACCOUNT_SUCCESS,
  payload,
  hasKey,
  signature,
});

export const fetchListAccountFailure = (): FetchListAccountFailure => ({
  type: FETCH_LIST_ACCOUNT_FAILURE,
});

export const fetchAccountDetailRequest = (payload?: ACCOUNT): FetchAccountDetailRequest => ({
  type: FETCH_ACCOUNT_DETAIL_REQUEST,
  payload,
});

export const fetchAccountDetailSuccess = (payload?: ACCOUNT): FetchAccountDetailSuccess => ({
  type: FETCH_ACCOUNT_DETAIL_SUCCESS,
  payload,
});

export const fetchAccountDetailFailure = (): FetchAccountDetailFailure => ({
  type: FETCH_ACCOUNT_DETAIL_FAILURE,
});

export const fetchLimitRemainRequest = (): FetchLimitRemainRequest => ({
  type: FETCH_LIMIT_REMAIN_REQUEST,
});

export const fetchLimitRemainSuccess = (payload?: string): FetchLimitRemainSuccess => ({
  type: FETCH_LIMIT_REMAIN_SUCCESS,
  payload,
});

export const fetchLimitRemainFailure = (): FetchLimitRemainFailure => ({
  type: FETCH_LIMIT_REMAIN_FAILURE,
});

export const fetchListAccountLoginRequest = (): FetchListAccountLoginRequest => ({
  type: FETCH_LIST_ACCOUNT_LOGIN_REQUEST,
});

export const fetchListAccountLoginSuccess = (
  payload?: RESPONSEDATA,
  hasKey?: string,
  signature?: string,
): FetchListAccountLoginSuccess => ({
  type: FETCH_LIST_ACCOUNT_LOGIN_SUCCESS,
  payload,
  hasKey,
  signature,
});

export const fetchListAccountLoginFailure = (): FetchListAccountLoginFailure => ({
  type: FETCH_LIST_ACCOUNT_LOGIN_FAILURE,
});

export const fetchCustomerPositionRequest = (): FetchCustomerPositionRequest => ({
  type: FETCH_CUSTOMER_POSITION_REQUEST,
});

export const fetchCustomerPositionSuccess = (payload?: ACCOUNT[]): FetchCustomerPositionSuccess => ({
  type: FETCH_CUSTOMER_POSITION_SUCCESS,
  payload,
});

export const fetchCustomerPositionFailure = (): FetchCustomerPositionFailure => ({
  type: FETCH_CUSTOMER_POSITION_FAILURE,
});
